<template>
  <v-footer color="primary lighten-1" padless>
    <v-row justify="center" no-gutters>
      {{ new Date().getFullYear() }} — <strong>Nemanja Đokić</strong>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "PageFooter",
  mounted() {
    console.log("rendereddd");
  },
};
</script>
